module.exports = __webpack_public_path__ + "static/media/HTC One A9 Black.1b875d60.png";